import  { useEffect, useState } from "react";
import { compose } from 'lodash'



export default function usePopupUrl() {


    const [currentPopUp, setCurrentPopup] = useState(null)

    function getCurrentPopup() {
        const url = new URL(window.location.href)
        const popup = url.searchParams.get('popup')
      
        return popup
    }
    
    
    function setPopup(popupName) {
      
        if (popupName) {
            const url = new URL(window.location.href)
            url.searchParams.set('popup', popupName.toLowerCase().trim())
           
       
        }
        return popupName
    }

    


    useEffect(() => {
    
        compose(setCurrentPopup, getCurrentPopup)()
    }, [])

    useEffect(() => {

        setPopup(currentPopUp)
    }, [currentPopUp])


    function changePopup(name) {
        setPopup('')
        setCurrentPopup(name.toLowerCase())
    }


    return [currentPopUp, changePopup]

}

